import { POST, GET } from "./ajax";
import request from "./request";
import { ARTICLE_TYPES, PURCHASE_TYPES } from "../consts/consts";
import foStorage from "../utils/foStorage";
import debounce from "lodash/debounce";
import utils from "../utils/utils";
import config from "../consts/config/index";

// 上传图片
async function uploadImage(data) {
  const img = await Promise.all(
    data.map(async item => {
      const { data } = await request.uploadImage(item);
      return data.url;
    })
  );

  return img;
}

function getAppConfig() {
  return GET(`/pub/config/get`);
}

function getMemberCheck() {
  return POST(`/member/check`);
}

function getHomeData() {
  return POST(`/home/index/index`);
}

function getHomeAd() {
  return POST(`/index/ad`);
}

function getHomeEvaluations() {
  return POST(`/index/evaluations`);
}

function doWeixinCodeLogin(code) {
  return POST(`/wechat/weixin/weixinLogin`, { code });
}

function weixinJsSdkSign(url = window.location.href, callback = utils.noop) {
  return POST(`/wechat/signature`, {
    url,
    source: utils.getOrganizationWechatAppId() || "0"
  }).then(callback);
}
const weixinJsSdkSignDebounce = debounce(weixinJsSdkSign, 500);

function getInviteRanking({ page_size = 20, page = 1 }) {
  return POST(`/member/rank/invite`, {
    page_size,
    page
  });
}

function getPointsRanking({ page_size = 20, page = 1 }) {
  return POST(`/member/rank/points`, {
    page_size,
    page
  });
}

function sendLoginSms({ mobile, type }) {
  return POST(`/mobile/sms`, {
    mobile,
    type
  });
}
function getHelpCenterQA() {
  return POST(`/member/me/help`);
}
function loginBySms({ mobile, code, key }) {
  return POST(`/auth/mobile`, {
    mobile,
    code,
    key
  });
}

function loginByPassword({ mobile, password, key }) {
  return POST(`/member/login/pwd`, {
    mobile,
    password,
    key
  });
}

function bindPhone({ mobile, code, key }) {
  return POST(`/mobile/bind`, {
    key,
    mobile,
    code,
    env: "wx"
  });
}

function bindPerfectInfo(data) {
  return POST(`/member/complete`, data);
}

// function getMyProfile() {
//   return POST(`/member/profile/overview`);
// }

function getMyProfile() {
  return POST(`/member/info`);
}

function getMyProfileHome() {
  return POST(`/member/me/home`);
}

function pointExchange({ points }) {
  return POST(`/member/points/exchange`, { points });
}

function getMyPurchaseList({
  type = undefined, // 不传，表示所有；34订阅，37课程
  page = 1,
  page_size = 20,
  ...others
}) {
  type = parseInt(type, 10);
  return POST(`/member/me/buy-log`, {
    type,
    page,
    page_size,
    ...others
  });
}

function qrCodeBuy({ scheme }) {
  return POST(`/member/qrcode/exchange`, {
    scheme
  });
}

function getToken(id, is_refresh) {
  return POST(
    `/im/user/token`,
    {
      member_id: id,
      is_refresh
    },
    { silence: true }
  );
}
function getChatRoomId(id) {
  return POST(`/im/chatroom/live`, {
    id
  });
}
function getHistroyMessage({ id, room_type = 1, last_msg_id, page_size = 20 }) {
  return POST(`/vod/comment/list`, {
    id,
    room_type,
    last_msg_id,
    page_size
  });
}

function getMyPointsList({ page = 1, page_size = 20, ...others }) {
  return POST(`/member/me/point-log`, {
    page,
    page_size,
    ...others
  });
}

function getColumnArticleList({
  page = 1,
  page_size = 20,
  sub_id, // 订阅id
  is_free = 0, // 是否是免费试读（1是 0否）
  order = 2, // 1倒序 2顺序默认倒序
  ...others
}) {
  return POST(`/sub/sub/content-list`, {
    page,
    page_size,
    sub_id,
    is_free,
    order,
    ...others
  });
}

function getMyMessagesList() {
  return POST(`/member/message/list`);
}

function clearMyMessages() {
  return POST(`/member/message/clear`);
}

/*
'7'=>'法商内参',
'8'=>'法商宝典',
'10'=>'法商模板',
'13'=>'法商头条',
'18'=>'法商大单'
 */
function getArticleList({
  cat_id = ARTICLE_TYPES.BAO_DIAN,
  page = 1,
  page_size = 20,
  ...others
}) {
  return POST(`/article/article/list`, {
    cat_id,
    page,
    page_size,
    ...others
  });
}

function getArticleCategoryDetail({ category_id, ...others }) {
  return POST(`/article/category/detail`, {
    category_id,
    ...others
  });
}

function getArticleCategoryList({
  category_id,
  page = 1,
  page_size = 20,
  ...others
}) {
  return POST(`/article/category/list`, {
    category_id,
    page,
    page_size,
    ...others
  });
}

function getArticleDetail({ id }) {
  return POST(`/article/article/detail`, {
    id
  });
}
function getLiveDetail({ id }) {
  return POST(
    `/vod/index/detail`,
    {
      id
    },
    { silence: true }
  );
}

function getLiveList({ page = 1, page_size = 20, ...other }) {
  return POST(
    `/vod/index/list`,
    {
      page,
      page_size,
      ...other
    },
    { silence: true }
  );
}

function doVodComment({ room_id, content, extra, user }) {
  return POST(
    `/vod/comment/chatroom`,
    {
      room_id,
      content,
      extra,
      user
    },
    { silence: true }
  );
}

function getSubList({ page, ...others }) {
  return POST(`/sub/sub/list`, {
    page,
    page_size: 20,
    ...others
  });
}

function getMySubList({ page, ...others }) {
  return POST(`/sub/sub/my-sub`, {
    page,
    page_size: 20,
    ...others
  });
}

function getSubContentDetail({ id }) {
  return POST(`/sub/sub/content-detail`, {
    id
  });
}

function getSubContent({ sub_id, is_free }) {
  return POST(`/sub/sub/detail`, {
    sub_id,
    is_free
  });
}

function getLessonList({ page = 1, page_size = 20, type, ...other }) {
  return POST(`/lesson/lesson/list`, {
    page,
    type,
    page_size,
    ...other
  });
}

function getMasterLessonList({ page, type = 1, page_size = 20, ...other }) {
  return POST(`/lesson/lesson/list`, {
    page,
    type,
    page_size,
    ...other
  });
}

function getExcellentLessonList({ page, type = 0, page_size = 20, ...other }) {
  return POST(`/lesson/lesson/list`, {
    page,
    type,
    page_size,
    ...other
  });
}

function getMyLessonList({ page, page_size = 20 }) {
  return POST(`/lesson/lesson/mylist`, {
    page,
    page_size
  });
}

function getLessonDetail({ id }) {
  return POST(`/lesson/lesson/detail`, {
    id
  });
}

function getBookDetail({ id }) {
  return POST(`/book/book/detail`, {
    id
  });
}

function getMineCoupons() {
  return POST(`/member/coupon/lists`);
}

function getLessonClassList({ lesson_id, page = 1, page_size = 20 }) {
  return POST(`/lesson/tutorial/list`, {
    lesson_id,
    page,
    page_size
  });
}

function getLessonLearn({ id, lesson_id }) {
  return POST(
    `/lesson/tutorial/detail`,
    {
      id,
      lesson_id
    },
    { silence: true }
  );
}
function getColumnLearn({ id }) {
  return POST(`/sub/sub/content-detail`, {
    id
  });
}

function checkWxLoginResult(obj) {
  return POST(`/auth/wechat`, obj);
}

function getPhoneCountryList() {
  return POST(`/member/country/list`);
}

function getAllQA({ page_size = 10, page, sort_type = 2 }) {
  return POST(`/qa/index/list/all`, {
    page,
    page_size,
    sort_type: sort_type
  });
}

function getFollowQA({ page_size = 10, page }) {
  return POST(`/qa/index/list/follow`, {
    page,
    page_size
  });
}

function getOwnQA({ page_size = 10, page }) {
  return POST(`/qa/index/list/own`, {
    page,
    page_size
  });
}

function deleteQa(id) {
  return POST(`/qa/index/delete`, {
    id
  });
}

function getQADetail(id) {
  return POST(`/qa/html/detail`, {
    id
  });
}

function getRefundDetail(id) {
  return POST(`/qa/index/refund`, {
    id
  });
}

function doLikeQA(id, type) {
  return POST(`/qa/index/like`, {
    id,
    type
  });
}

function follow({ id, type }) {
  return POST(`/qa/index/follow`, {
    id,
    type: type
  });
}

function doLikeQAComment(id, type) {
  return POST(`/qa/comment/like`, {
    id,
    type
  });
}

function getQACommentList({ qa_id, page = 1, page_size = 20 }) {
  return POST(`/qa/comment/list`, {
    qa_id,
    page,
    page_size
  });
}

function getQACommentChildren({ qa_id, parent_id, page = 1, page_size = 20 }) {
  return POST(`/qa/comment/list/children`, {
    qa_id,
    parent_id,
    page,
    page_size
  });
}

function getQACommentDetail({ id }) {
  return POST(`/qa/comment/detail`, { id });
}

function getLecturerList({ type } = {}) {
  return POST(`/qa/lecturer/list`, { type });
}

function getQAClassList() {
  return POST(`/qa/class/list`);
}

function doQAComment({ qa_id, parent_id, content }) {
  return POST(`/qa/comment/commit`, {
    qa_id,
    parent_id,
    content
  });
}

function doQAnswerReply({ content, qa_id, file_type, file_url }) {
  return POST(`/qa/answer/reply`, {
    content,
    qa_id,
    file_type,
    file_url
  });
}

function doDeleteQAComment({ id }) {
  return POST(`/qa/comment/delete`, { id });
}

function doQACommit({
  class_id,
  content = "",
  items = [],
  reply_type = "0", // 0 文字 1 语音
  replier_id,
  price,
  is_public,
  is_anonymous
}) {
  return POST(`/qa/index/commit`, {
    class_id,
    content,
    items,
    reply_type,
    replier_id,
    price,
    is_public,
    is_anonymous
  });
}

function doLookQA(qa_id) {
  return POST(`/qa/html/look`, {
    qa_id
  });
}
function doLookQAAnswer(qa_id) {
  return POST(`/qa/answer/look`, {
    qa_id
  });
}

function getThemesList() {
  return POST(`/activity/angle/themes`);
}

function getAngelDetail(theme_id) {
  return POST(`/activity/angle/detail`, {
    theme_id
  });
}

function angelReceive(mobile, invited_id, key) {
  return POST(
    `/activity/angle/receive`,
    {
      mobile,
      invited_id,
      key
    },
    { silence: true }
  );
}

function saveWechat({
  media_id,
  scale,
  top,
  left,
  width,
  height,
  imgHeight,
  imgWidth
}) {
  return POST(`/activity/angle/saveWechat`, {
    media_id,
    scale,
    top,
    left,
    width,
    height,
    image_height: imgHeight,
    image_width: imgWidth
  });
}

function getCommentDetail({ id, type }) {
  return POST(`/comment/comment/comment-detail`, {
    id,
    type
  });
}

function getCommentList({ id, type, page = 1, page_size = 20 }) {
  return POST(`/comment/comment/get-comment`, {
    id,
    type,
    page,
    page_size
  });
}

function doComment({ id, content, parent_id, type }) {
  return POST(`/comment/comment/comment`, {
    id,
    content,
    parent_id,
    type
  });
}

function doLikeComment({ id, fun, type }) {
  return POST(`/comment/comment/comment-likes`, {
    id,
    fun,
    type
  });
}

function getCouponDrawDetail({ coupon_share_id, mobile, key }, config = {}) {
  return POST(
    `/member/coupon/receive-share-home`,
    {
      coupon_share_id,
      mobile,
      key
    },
    config
  );
}

function doDrawRedPacket({ coupon_share_id, mobile, key }, config = {}) {
  return POST(
    `/member/coupon/receive-share-coupon`,
    {
      coupon_share_id,
      mobile,
      key
    },
    config
  );
}

function getPostDetail({ id }) {
  return POST(`/lesson/post/detail`, {
    id
  });
}

function getPayInfo(data = {}) {
  return POST(`/pay/common/payInfo`, data);
}

function doPayment(data = {}, config = {}) {
  return POST(`/pay/common/order`, data, config);
}

/*商城对应接口*/
function getGoodsBaner({ type }) {
  return POST(`/shop/shop/ad`, {
    type
  });
}
function getGoodsShopping() {
  return POST(`/shop/shop/home`);
}

function getGoodsList({ classify_id, page = 1, page_size = 20 }) {
  return POST(`/shop/shop/goods`, {
    classify_id,
    page,
    page_size
  });
}
function getGoodsCartDetail({ gid }) {
  return POST(`/shop/shop/addCart`, {
    gid
  });
}

function addShoppingCart({ gid, sid, num, tp }) {
  return POST(`/shop/shop/doAddCart`, {
    gid,
    sid,
    num,
    tp
  });
}

function getGoodsInfo({ gid }) {
  return POST(`/shop/shop/info`, {
    gid
  });
}

function getGoodsOrderList({ page_size = 10, page, state }) {
  return POST(`/shop/shop/orderList`, {
    state,
    page,
    page_size
  });
}

function cancelOrder({ id }) {
  return POST(`/shop/shop/cancelOrder`, {
    id
  });
}

function getGoodsOrderDetail({ id, order_sn }) {
  return POST(`/shop/shop/orderInfo`, {
    id,
    order_sn
  });
}

/**
 platform	Y	string	平台（微信和小程序）：wx,wxa
 type	Y	string	购买类型：vod(直播点播)，sub(订阅)， lesson(课程)，wxa_lesson（小程序购买课程）,wxa_group_buy_lesson（小程序团购课程）
 id	Y	string	对应类型的ID
 is_group	Y	int	是否团购，0：非团购，1：团购
 group_id	Y	int	拼团ID，团购时传0，拼团购买时传对应的拼团ID
 give_member_mobile	Y	string	赠送人手机号码，非赠送传空字符串
 invite_id	Y	int	邀请人ID，非邀请购买传0
 open_id	Y	string	用户微信open_id
 * @param id
 * @param platform
 * @param type
 * @returns {*}
 */
function buyOnlineProductWx({ id, type = PURCHASE_TYPES.lesson, params = {} }) {
  const open_id = "TODO";
  const platform = "wx";
  const { give_member_mobile, invite_id } = params;

  return POST(`/pay/wechat/online`, {
    id,
    platform,
    type,
    // is_group,
    // group_id
    give_member_mobile,
    invite_id,
    open_id
  });
}

/**
 offline_id	Y	string	线下产品ID
 mobile	Y	string	用户手机号码
 receiver	Y	string	购买用户姓名
 open_id	Y	string	用户微信open_id
 num	N	int	购买数量，默认为1
 note	N	string	购买留言
 wechat	N	string	用户微信号，线下课程、年会产品购买必传
 email	N	string	用户邮箱，线下课程、年会产品购买必传
 company	N	string	用户单位，线下课程、年会产品购买必传
 position	N	string	用户职位
 referral	N	string	推荐人
 address_id	N	int	地址ID，线下课程购买必传
 size_id	N	int	规格ID，线下课程、年会产品、卡券购买必传
 platform	N	string	平台微信或者小程序，wx/wxa
 */
function buyOfflineProductWx({
  id,
  type = PURCHASE_TYPES.offline,
  params = {}
}) {
  const open_id = "TODO";
  const platform = "wx";
  const offline_id = id;
  const {
    mobile,
    receiver,
    num,
    note,
    wechat,
    email,
    company,
    position,
    referral,
    address_id,
    size_id
  } = params;

  return POST(`/pay/wechat/offline`, {
    platform,
    offline_id,
    open_id,
    mobile,
    receiver,
    num,
    note,
    wechat,
    email,
    company,
    position,
    referral,
    address_id,
    size_id
  });
}

// 直播点播内购
function buyVod({ id }) {
  return POST(`/vod/index/buy`, { id });
}

// 订阅专栏内购
function buyColumn({ id }) {
  return POST(`/sub/sub/buy`, {
    sub_id: id
  });
}

// 课程内购
function buyCourse({
  id,
  cid, // 红包id（没有红包不用传）
  mobile // 被赠送者手机号码，不传表示不赠送
}) {
  return POST(`/lesson/lesson/buy`, {
    t: foStorage.getItem(foStorage.KEYS.token),
    id,
    cid,
    mobile
  });
}

// 礼品卡详情
function getGiftCardDetail({ card_number }) {
  return POST(`/welfare/gift-card/card`, { card_number });
}

// 礼品卡兑换
function doExchangeGiftCard({ card_number, password }) {
  return POST(`/welfare/gift-card/exchange`, {
    card_number,
    password
  });
}

// 问答围观购买
function buyQA({ id }) {
  return POST(`/qa/answer/look`, {
    qa_id: id
  });
}

function getExpertDetail({ id }) {
  return POST(`/qa/lecturer/detail`, {
    id: id
  });
}

function getExpertList() {
  return POST(`/qa/lecturer/list`);
}

function getLessinList({ page_size = 5, page = 1, id }) {
  return POST(`/lesson/class/list/all`, {
    page_size,
    page,
    mid: id
  });
}

function getQAList({ page_size = 5, page = 1, sort_type = 2, id }) {
  return POST(`/qa/index/list/all`, {
    sort_type: sort_type,
    page_size: page_size,
    page: page,
    replier_id: id
  });
}

// 商城购买 TODO
function buyMall() {}

// 充值 TODO
function buyRecharge() {}

// 线下购买 TODO
function buyOfflineProduct() {}

// 签到
/**
 *
 * @param date 日期, 格式: 2018-3-21
 * @returns {*}
 */
function buySign({ date }) {
  return POST(`/welfare/sign/cover`, { date });
}

// 获取所有省市区信息
function getAreaInfo() {
  return POST(`/shop/shop/areaInfo`);
}

function getLessonExams({ tutorial_id, page = 1, page_size = 200 }) {
  return POST(`/lesson/exercise/list`, {
    tutorial_id,
    page,
    page_size
  });
}

function submitLessonExams({ tutorial_id, lesson_id, answers }) {
  return POST(`/lesson/exercise/submit`, { tutorial_id, lesson_id, answers });
}

// 添加收货地址
function doAddAddress({ name, phone, provice_id, city_id, area_id, addr }) {
  return POST(`/shop/shop/addAddr`, {
    name,
    phone,
    provice_id,
    city_id,
    area_id,
    addr
  });
}

// 修改收货地址
function doUpdateAddress({
  name,
  phone,
  provice_id,
  city_id,
  area_id,
  addr,
  id
}) {
  return POST(`/shop/shop/updateAddr`, {
    name,
    phone,
    provice_id,
    city_id,
    area_id,
    addr,
    id
  });
}

// 删除收货地址
function doDeleteAddress({ id }) {
  return POST(`/shop/shop/delAddr`, { id });
}

// 获取我的收货地址
function getMineAddressList() {
  return POST(`/shop/shop/addrList`);
}

// 我的购物车
function getMineCart() {
  return POST(`/shop/shop/cart`);
}

// 删除购物车中的商品
function doRemoveCartItems({ id }) {
  return POST(`/shop/shop/delCart`, { id });
}

// 修改购物车中商品的数量
function doUpdateCartItemNum({ cid, num }) {
  return POST(`/shop/shop/updateCartNum`, { cid, num });
}

// 确认订单
function doConfirmOrder({
  pay_type,
  target_type,
  target_id,
  platform,
  gift_mobile,
  group_info,
  invite_id,
  num,
  params
}) {
  return POST(`/pay/common/payInfo`, {
    pay_type,
    target_type,
    target_id,
    platform,
    gift_mobile,
    group_info,
    invite_id,
    num,
    params
  });
}

// 获取报名信息
function getRegistractions() {
  return POST(`shop/shop/registration`);
}

// 新增/修改报名信息
function doCreateOrUpdateRegistraction({
  name,
  phone,
  id,
  email,
  referrer,
  wechat,
  company,
  job
}) {
  return POST(`/shop/shop/saveRegistration`, {
    name,
    phone,
    id,
    email,
    referrer,
    wechat,
    company,
    job
  });
}

// 创建订单
function doCreateOrder(params) {
  return POST(`/shop/shop/addOrder`, params, { silence: true });
}

function wxPayCheck({ code }) {
  return POST(`/pay/common/check`, { code });
}

function getColumnShareInfo({ id, key }) {
  const wxKey = utils.getWeixinAuthKey();
  return POST(`/sub/sub/share-read`, { id, key, wxKey });
}

function robColumnRead({ id, key }) {
  const wxKey = utils.getWeixinAuthKey();
  return POST(`/sub/sub/rob-read`, { id, key, wxKey });
}

function getColumnRobUsersList({ key }) {
  return POST(`/sub/sub/rob-user-list`, { key });
}

function doCheckShopGoods({ goods }) {
  return POST(`/shop/shop/checkShop`, { goods }, { silence: true });
}

function getVodDetail({ id }) {
  return POST(`/vod/index/video-detail`, { id });
}

function gitRiskDiagnosisTemplate() {
  return POST(`/risk/risk/temp`);
}

function submitNewRiskDiagnosis(riskData) {
  return POST(`/risk/risk/editRisk`, riskData);
}

function getRiskDiagnosisList({ page_size = 20, page = 1 }) {
  return POST(`/risk/risk/myRiskList`, {
    page,
    page_size
  });
}

function getRiskDiagnosisDetail(risk_id) {
  return POST(`/risk/risk/myRisk`, {
    risk_id
  });
}

function sendRiskDiagnosisEmail({
  email,
  image // base64图片流
}) {
  return POST(`/risk/risk/emailShare`, {
    email,
    image
  });
}

function saveRiskDiagnosisImage({ risk_id, image }) {
  return POST(`/risk/risk/upImg`, {
    risk_id,
    image: config.encodeAjaxData ? image : encodeURIComponent(image)
  });
}

function fetchTurnTableData() {
  return POST(`/welfare/turntable/home`, {
    key: utils.isFoApp()
      ? undefined
      : foStorage.getItem(foStorage.KEYS.wxAuthKey) || undefined
  });
}

function doLotteryTurnTable({ ac_id }, config = {}) {
  return POST(
    `/welfare/turntable/start`,
    {
      ac_id,
      key: utils.isFoApp()
        ? undefined
        : foStorage.getItem(foStorage.KEYS.wxAuthKey) || undefined
    },
    config
  );
}

function getMyPrizeList({ page = 1, page_size = 20, ...others }) {
  return POST(`/welfare/turntable/reward`, {
    page,
    page_size,
    key: utils.isFoApp()
      ? undefined
      : foStorage.getItem(foStorage.KEYS.wxAuthKey) || undefined,
    ...others
  });
}

function doReceiveReward({ ac_id, receive_id }) {
  return POST(`/welfare/turntable/receive`, {
    ac_id,
    receive_id,
    key: utils.isFoApp()
      ? undefined
      : foStorage.getItem(foStorage.KEYS.wxAuthKey) || undefined
  });
}

function getGoodsPoints({ goods }) {
  return POST(`/shop/shop/usePoints`, {
    goods
  });
}

function doCompleteMyInfo(info = {}) {
  return POST(`/welfare/member-prefect-info/set`, info);
}

function getCompleteInfoShare() {
  return POST(`/welfare/member-prefect-info/share`);
}

function getCityJson() {
  return POST(`/home/province/json`);
}

function getPointRule() {
  return POST(`/member/points/rewardRule`);
}

/// 我的红包列表
function getMyRedPacket() {
  return POST(`/member/coupon/lists`);
}

/// sub、class 可用红包
function getRedPacket({ type, sum }) {
  return POST(`/member/coupon/find-can-coupon`, {
    type: type,
    sum: sum
  });
}

function getPointsCoinsByKey({ key }) {
  return POST(`/member/qrcode/exchange`, {
    scheme: window.location.href
  });
}

function getCounselorList({ page = 1, pagesize = 10 } = {}) {
  return POST(`/mentor/list`, {
    page,
    pagesize
  });
}

// 获取爱心互动列表
function getSocialList({ page = 1, pagesize = 10 } = {}) {
  return POST(`/social/index/list`, {
    page,
    pagesize
  });
}

// 获取爱心互动详情
function getSocialDetail(id) {
  return POST(`/social/index/detail`, {
    id
  });
}

function getCounselorDetail(id) {
  return POST(`/mentor/detail`, {
    id
  });
}

function doSubmitConsult(params) {
  return POST(`/consult/consult/consultSub`, params);
}

// 全局搜索
export const doSearch = params => {
  return request.post(`/search/search/query`, params);
};

// 获取热门关键词
export const getHotWord = params => {
  return request.post(`/search/hotword/list`, params);
};

// 创建订单
export const orderCreate = params => {
  return request.post(`/order/create`, params);
};

// 创建交流倾听订单
export const orderConsultCreate = params => {
  return request.post(`/order/consult`, params);
};

// 创建专家预约订单
export const orderMentorCreate = params => {
  return request.post(`/order/mentor`, params);
};

// 测评列表
export const getEvaluationList = params => {
  return request.post(`/evaluation/list`, params);
};

// 测评结果列表
export const getEvaluationResultList = params => {
  return request.post(`/evaluation/resultList`, params);
};

// 检查是否已经完善信息
export const checkPerfectedProfile = params => {
  return request.post(`/risk/evaluation/check-member`, params);
};

// 测评项目
function fetchEvaluationProject(params) {
  return request.post(`/evaluation/detail`, params);
}
// 测评项目问答列表
function fetchEvaluationQuestions(params) {
  return request.post(`/evaluation/questions`, params);
}

//  提交测试
function saveEvaluationAnswers(params) {
  return request.post(`/evaluation/submit`, params);
}

// 完善信息界面
export function companyCodeBind(params) {
  return request.post(`/company/bind`, params);
}
export function companyCodeList(params) {
  return request.post(`/company/list`, params);
}
export function schoolCodeBind(params) {
  return request.post(`/school/bind`, params);
}
export function schoolCodeList(params) {
  return request.post(`/school/list`, params);
}
export function authSchool(params) {
  return request.post(`/auth/school`, params);
}

// 完善信息界面
function fetchEvaluationMemberPanel(params) {
  return request.post(`/risk/evaluation/company-code`, params);
}

// 完善信息
function saveEvaluationMember(params) {
  return request.post(`/risk/evaluation/member`, params);
}

// 测评结果绑定单位
function saveEvaluationResultBind(params) {
  return request.post(`/risk/evaluation/result-bind`, params);
}

// 校验测评任务是否正常
function saveEvaluationCheckEvaTask(params) {
  return request.post(`/risk/evaluation/checkEvaTask`, params);
}

// 测评结果
function fetchEvaluationResult(params) {
  return request.post(`/evaluation/result`, params);
}

// 获取咨询相关协议
function getConsultProtocols(code) {
  return request.post(`/pub/config/option`, {
    code
  });
}

// 我的咨询
function getMineConsults(params) {
  return request.post(`/order/mentor/list`, {
    page_size: 10,
    ...params
  });
}
// 我的交流倾听
function getMineConsultsOrder(params) {
  return request.post(`/order/consult/list`, {
    page_size: 10,
    ...params
  });
}

// 咨询详情
function getConsultDetail(id) {
  return request.post(`/consult/consult/consultInfo`, {
    id
  });
}

// 咨询预约详情
function fetchConsulorAppointmentDetail(params) {
  return request.post(`/`, params);
}

// 申诉
function saveConsulorAppeal(params) {
  return request.post(`/`, params);
}

// 取消咨询订单
function doCancelConsult(id) {
  return request.post(`/consult/consult/cancelConsult`, {
    id
  });
}

// 获取机构信息
function getCompanyInfo() {
  return POST(`/home/company/info`);
}

export default {
  authSchool,
  getMineConsultsOrder,
  bindPerfectInfo,
  getMemberCheck,
  getHomeEvaluations,
  getHomeAd,
  uploadImage,
  getCompanyInfo,
  doSearch,
  getAppConfig,
  getHomeData,
  doWeixinCodeLogin,
  weixinJsSdkSign,
  weixinJsSdkSignDebounce,
  getInviteRanking,
  getPointsRanking,
  sendLoginSms,
  loginBySms,
  loginByPassword,
  bindPhone,
  getMyProfile,
  getMyProfileHome,
  getMyPurchaseList,
  getMyPointsList,
  getMyMessagesList,
  getColumnArticleList,
  clearMyMessages,
  getArticleList,
  getArticleDetail,
  getAllQA,
  getFollowQA,
  getOwnQA,
  getQADetail,
  getRefundDetail,
  doLookQA,
  doLikeQA,
  follow,
  deleteQa,
  doLikeQAComment,
  doLookQAAnswer,
  getExpertDetail,
  getExpertList,
  getLessinList,
  getQAList,
  getThemesList,
  getAngelDetail,
  angelReceive,
  saveWechat,
  getSubList,
  getMySubList,
  getSubContentDetail,
  getSubContent,
  getMineCoupons,
  checkWxLoginResult,
  getPhoneCountryList,
  getMasterLessonList,
  getExcellentLessonList,
  getLessonList,
  getMyLessonList,
  getLessonDetail,
  getBookDetail,
  getCommentDetail,
  getCommentList,
  doComment,
  doLikeComment,
  getCouponDrawDetail,
  doDrawRedPacket,
  getGiftCardDetail,
  doExchangeGiftCard,
  getLessonClassList,
  buyOnlineProductWx,
  buyOfflineProductWx,
  getLessonLearn,
  getColumnLearn,
  getPostDetail,
  getAreaInfo,
  getLessonExams,
  submitLessonExams,
  doAddAddress,
  doUpdateAddress,
  doDeleteAddress,
  getMineAddressList,
  getMineCart,
  doRemoveCartItems,
  doConfirmOrder,
  doUpdateCartItemNum,
  getPayInfo,
  doPayment,
  getGoodsBaner,
  getGoodsShopping,
  getRegistractions,
  getGoodsList,
  getGoodsCartDetail,
  addShoppingCart,
  getGoodsInfo,
  doCreateOrUpdateRegistraction,
  doCreateOrder,
  getGoodsOrderList,
  getGoodsOrderDetail,
  cancelOrder,
  wxPayCheck,
  getColumnShareInfo,
  robColumnRead,
  getColumnRobUsersList,
  getLiveList,
  getLiveDetail,
  doVodComment,
  getHelpCenterQA,
  pointExchange,
  doCheckShopGoods,
  getVodDetail,
  doQAComment,
  getQACommentList,
  getQACommentChildren,
  doDeleteQAComment,
  getQACommentDetail,
  getLecturerList,
  getQAClassList,
  doQACommit,
  doQAnswerReply,
  qrCodeBuy,
  getToken,
  getChatRoomId,
  getHistroyMessage,
  gitRiskDiagnosisTemplate,
  submitNewRiskDiagnosis,
  getRiskDiagnosisList,
  getRiskDiagnosisDetail,
  sendRiskDiagnosisEmail,
  saveRiskDiagnosisImage,
  fetchTurnTableData,
  doLotteryTurnTable,
  getMyPrizeList,
  doReceiveReward,
  getGoodsPoints,
  doCompleteMyInfo,
  getCompleteInfoShare,
  getCityJson,
  getPointRule,
  getMyRedPacket,
  getRedPacket,
  getPointsCoinsByKey,
  getCounselorList,
  getSocialList,
  getSocialDetail,
  getCounselorDetail,
  doSubmitConsult,
  fetchEvaluationProject,
  fetchEvaluationQuestions,
  saveEvaluationAnswers,
  fetchEvaluationMemberPanel,
  saveEvaluationMember,
  saveEvaluationResultBind,
  saveEvaluationCheckEvaTask,
  fetchEvaluationResult,
  getConsultProtocols,
  getMineConsults,
  getConsultDetail,
  fetchConsulorAppointmentDetail,
  saveConsulorAppeal,
  doCancelConsult,
  getArticleCategoryDetail,
  getArticleCategoryList
};



// WEBPACK FOOTER //
// ./src/api/api.js